import client from './client';

export interface FamilyMemberPayload {
  name:                 string;
  relationship:         string;
  gender?:              string;
  dob?:                 string | null;
  status?:              string;
  phone?:               string;
  occupation?:          string;
  qualification?:       string;
  bloodGroup?:          string;
  email?:               string;
  baptizedDate?:        string | null;
  marriageDate?:        string | null;
  isAdmin?:             boolean;
  legionOfMary?:        boolean;
  isVincentDePaul?:     boolean;
  isChoir?:             boolean;
  isCatechismTeacher?:  boolean;
  isWomenAssoc?:        boolean;
  isLiturgyCouncil?:    boolean;
  isAlterServices?:     boolean;
  isYouth?:             boolean;
  confirmationDate?:    string | null;
  firstCommunionDate?:  string | null;
  priesthoodDate?:      string | null;
  memberGroup?:         string;
  childClass?:          string;
  childInstitution?:    string;
}

export const listFamilyMembers = async (familyId: number): Promise<Record<string, unknown>[]> => {
  const { data } = await client.get<{ data: { members: Record<string, unknown>[] } }>(`/family/${familyId}/members`);
  return data.data.members;
};

export const createFamilyMember = async (familyId: number, payload: FamilyMemberPayload) => {
  const { data } = await client.post(`/family/${familyId}/members`, payload);
  return data.data;
};

export const updateFamilyMember = async (familyId: number, memberId: number, payload: FamilyMemberPayload) => {
  const { data } = await client.put(`/family/${familyId}/members/${memberId}`, payload);
  return data.data;
};

export const deleteFamilyMember = async (familyId: number, memberId: number): Promise<void> => {
  await client.delete(`/family/${familyId}/members/${memberId}`);
};
